<template>
	<div>
		<Layout :navFixed="true" :transparent="true">
			<div class="container mt-3">
				<div class="row row-xs d-flex">
					<div class="col-12 mt-4 mb-4">
						<h1>Mi cuenta</h1>
					</div>
				</div>
				<div class="row row-xs d-flex no-wrap">
					<AccountSidebar tab="events" />

					<div class="page" v-if="eventPromoted">
						<div class="card mb-3">
							<div class="card-body">
								<EventCard :eventId="eventPromoted.event.id" />

								<div class="mt-3">
									<ShareLink :link="eventPromoted.publicLink" />
								</div>
							</div>
						</div>

						<div class="card mb-3">
							<div class="card-body">
								<h5>Tickets vendidos</h5>
								<TicketList :promotorId="promotorId" :hideEventColumn="true" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</Layout>
	</div>
</template>

<script>
import gql from "graphql-tag"
import Layout from "@/components/Layout"
import ShareLink from "@/components/ShareLink"
import AccountSidebar from "./AccountSidebar"
import EventCard from "@/views/events/EventCard"
import TicketList from "./TicketList"

export default {
	name: "PromoteEvent",
	components: {
		Layout,
		ShareLink,
		AccountSidebar,
		EventCard,
		TicketList
	},
	data() {
		return {
			eventPromoted: null,
			loading: true,
			promotorId: null
		}
	},
	beforeMount() {
		console.log(this.$store.getters.loggedUser.id)
		this.promotorId = this.$store.getters.loggedUser.id
		this.load()
	},
	methods: {
		load() {
			return this.$apollo
				.query({
					query: gql`
						query($id: ID!) {
							eventPromoted(id: $id) {
								id
								publicLink
								ticketsSold
								event {
									id
									name
									startAt
									image {
										id
										url
										urlThumb
									}
								}
							}
						}
					`,
					variables: {
						id: this.$route.params.id
					},
					fetchPolicy: "network-only"
				})
				.then(({ data }) => {
					this.eventPromoted = data.eventPromoted
					this.loading = false
				})
		}
	}
}
</script>

<style scoped lang="scss">
.page {
	flex-grow: 1;
	flex-shrink: 1;
}
.no-wrap {
	flex-wrap: nowrap;
}
</style>
